import { FC, ReactElement } from 'react'
import cn from 'classnames'
import styles from './EmptyMessage.module.scss'

interface EmptyMessageProps {
  className?: string
  text: string | ReactElement
}
export const EmptyMessage: FC<EmptyMessageProps> = ({ className, text }) => {
  return <div className={cn(styles.container, className)}>{text}</div>
}
